<div class="flex flex-col relative" [style.background-color]="deckCard.color">
    <div class="flex flex-row items-center gap-[1ch] border-t border-ponder-light border-opacity-10">
        <div class="w-[3ch] text-slate-800 text-opacity-50 text-center text-xs sm:text-sm">
            {{ getCollectedCount() }}
        </div>
        <div>
            @if (isOwnDeck)
            {
                <input 
                    #cardCountInput 
                    (change)="onCardCountInput(cardCountInput)" 
                    class="bg-transparent w-[2ch] text-center"
                    [ngClass]="{ 'text-foil-dark' : deckCard.specialCount > 0 }"
                    type="text" 
                    value="{{ deckCard.count + deckCard.specialCount }}" 
                    size="2" 
                    maxlength="2" 
                    pattern="[0-9]{2}">
            } @else {
                <div class="bg-transparent w-[2ch] text-center">
                    {{ deckCard.count + deckCard.specialCount }}
                </div>
            }
        </div>
        <div class="w-[20ch] hover:cursor-pointer truncate text-xs sm:text-sm" [ngClass]="{ 'text-foil-dark' : deckCard.specialCount > 0 }">
            <a href="{{ getUrl() }}">{{ getCardName() }}</a>
        </div>
        <div #manaValue class="w-[12ch] items-end justify-end grow">
            {{ getManaValue() }}
        </div>
        <div class="w-[6ch] truncate text-xs text-slate-400">
            {{ getRowValue() }}
        </div>
        <div class="align-middle hover:cursor-pointer">
            <div class="flex justify-end">
                @if (isOwnDeck || isMobileScreen()) {
                    @if (!displayRowEdit) {
                        <button class="w-6" (click)="onEditClicked($event)">
                            <svg class="pl-1 w-5 h-5 fill-none stroke-ponder-light" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <title>Edit</title>
                                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="editSvgIcon" />
                            </svg>
                        </button>
                    } @else {
                        <button class="w-6">
                            <svg class="pl-1 w-5 h-5 fill-none stroke-ponder-light" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <title>Close</title>
                                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                            </svg>
                        </button>
                    }
                } @else {
                    <div class="w-6"></div>
                }
            </div>
        </div>
    </div>
    @if (displayRowEdit) {
        <magic-deck-card-dialog 
            [deck]="deck" 
            [deckComponent]="deckComponent"
            [deckLayerComponent]="deckLayerComponent"
            [deckCard]="deckCard" 
            [deckRow]="this"
            [isOwnDeck]="isOwnDeck"></magic-deck-card-dialog>
    }
</div>